import React, { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import {
  getFreeGuideBasicDetailsApi,
  getGuideBasicDetailsApi,
} from "../../api/candidate";
import WebUtils from "../../utils/WebUtils";
import Loader from "../../components/Loader";
import Sidebar from "../../components/Sidebar";
import Topbar from "../../components/Topbar";
import Content from "../../components/orgAdmin/prepGuides/preparation/prepareGuide/Content";
import ManageStudents from "../../components/orgAdmin/prepGuides/preparation/prepareGuide/ManageStudents";
import { Segmented } from "antd";
import { ROLES } from "../../constants/UserRoles";

function OrgAdminViewGuide() {
  const { jobGuideIdentifier } = useParams();
  const [searchParams] = useSearchParams();
  const industryId = searchParams.get("industryId");
  const [tab, setTab] = useState("manageStudents");
  const [loading, setLoading] = useState(false);
  const [basicGuideDetails, setBasicGuideDetails] = useState(null);

  const getBasicGuideDetails = () => {
    let url = "";
    if (industryId) {
      url = `${getFreeGuideBasicDetailsApi}?jobGuideIdentifier=${jobGuideIdentifier}`;
    } else {
      url = `${getGuideBasicDetailsApi}?jobGuideIdentifier=${jobGuideIdentifier}`;
    }

    setLoading(true);
    WebUtils.httpOperations(url, {}, "GET")
      .then((result) => {
        setLoading(false);
        if (
          result.data.resultStatusInfo.resultCode.toLowerCase() === "success"
        ) {
          setBasicGuideDetails(result.data.data);
        }
      })
      .catch((err) => {
        setLoading(false);
        console.log(err);
      });
  };

  useEffect(() => {
    if (jobGuideIdentifier) getBasicGuideDetails();
  }, [jobGuideIdentifier]);

  return (
    <>
      {loading && <Loader />}

      <div className="hirePlusPlusPageContent">
        <Sidebar activePage="preparationGuides" userRole={ROLES.org_admin} />
        <div className="w-full hireplusplusRightContent">
          <Topbar
            activePage="preparationGuides"
            userRole={ROLES.org_admin}
            newTitle={`Prepare Guide (${basicGuideDetails?.jobTitle || "N/A"})`}
          />
          <div className="px-5">
            <div className="mt-3 flex justify-start items-start">
              <Segmented
                options={[
                  {
                    label: "Manage Students",
                    value: "manageStudents",
                  },
                  {
                    label: "Content",
                    value: "content",
                  },
                ]}
                block
                className="max-w-[400px] w-full"
                onChange={(value) => {
                  setTab(value);
                }}
              />
            </div>

            <div>
              {tab === "manageStudents" && (
                <ManageStudents
                  jobGuideIdentifier={jobGuideIdentifier}
                  setLoading={setLoading}
                />
              )}

              {tab === "content" && (
                <Content
                  basicGuideDetails={basicGuideDetails}
                  industryId={industryId}
                  jobGuideIdentifier={jobGuideIdentifier}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default OrgAdminViewGuide;
